// extracted by mini-css-extract-plugin
module.exports = {"root":"TagsInput_root__WuKOf","tags":"TagsInput_tags__3D93l","tag":"TagsInput_tag__lG6oV","removeTag":"TagsInput_removeTag__afjZC"};